














import axios from 'axios';
import Vue from 'vue';
import HoteltList from '@/components/HoteltList.vue';
import BasePagination from '@/components/BasePagination.vue';

export default Vue.extend({
  name: 'App',
  components: {
    HoteltList,
    BasePagination,
  },
  data: () => ({
    hotels: null,
    hotelsLoading: false,
    page: 1,
    itemsPerPage: 10,
    visiblePagesCount: 5,
    itemsCount: 0,
  }),
  computed: {
  },
  methods: {
    getHotelsCount(): void {
      axios
        .get('https://jsonplaceholder.typicode.com/posts')
        .then((response) => {
          this.itemsCount = response.data.length;
        })
        .catch((error) => console.log(error));
    },
    loadHotels(): void {
      this.hotelsLoading = true;
      axios
        .get(`https://jsonplaceholder.typicode.com/posts?_page=${this.page}&_limit=10`)
        .then((response) => {
          this.hotels = response.data;
        })
        .then(() => { this.hotelsLoading = false; })
        .catch((error) => console.log(error));
    },
    paginatePage(clickPage: number): void {
      this.page = clickPage;
    },
  },
  watch: {
    page() {
      this.loadHotels();
    },
  },
  created() {
    this.getHotelsCount();
    this.loadHotels();
  },
});
